import React from 'react';
import moment from 'moment';
import { Typography, Descriptions, Spin, Empty } from 'antd';
import InfoCard from '../../common/InfoCard/InfoCard';
import { CardChangeButton } from '../../../../../components/Card';
import AddInfoBlock from '../AddInfoBlock/AddInfoBlock';
import styles from './AboutHouse.module.scss';

const types = {
  1: 'Многоквартирный дом',
};

const { Paragraph } = Typography;
const { Item } = Descriptions;

const AboutHouse = ({
  className,
  loading = false,
  data = {},
  address,
  children,
  onChangeButtonClick,
}) => {
  return (
    <InfoCard
      title="Общая информация"
      // action={
      //   !!Object.keys(data).length &&
      //   typeof onChangeButtonClick === 'function' && (
      //     <CardChangeButton onClick={onChangeButtonClick} disabled={loading} />
      //   )
      // }
      className={className}
    >
      <Spin
        wrapperClassName={styles.spin}
        style={{ display: 'contents' }}
        spinning={loading}
      >
        {!Object.keys(data).length && (
          // <AddInfoBlock onAddBtnClick={onChangeButtonClick} />
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
        {!!Object.keys(data).length && (
          <>
            <Typography className={styles.typography}>
              <Paragraph className={styles.typographyAddress}>
                {`${data.city.fullCity}, ${address}`}
              </Paragraph>
              <Paragraph className={styles.typographyHouseType}>
                {types[data.type.id]}
              </Paragraph>
            </Typography>
            <Descriptions column={3} className={styles.descriptions}>
              <Item span={3} label="Год постройки">
                {data.buildingDate
                  ? moment(data.buildingDate).format('YYYY')
                  : '-'}
              </Item>
              <Item span={3} label="Год ввода в эксплуатацию">
                {data.commissioningDate
                  ? moment(data.commissioningDate).format('YYYY')
                  : '-'}
              </Item>
              <Item span={1} label="Этажей">
                {data.floorCount || '-'}
              </Item>
              <Item span={2} label="Подъездов">
                {data.entranceCount || '-'}
              </Item>
              <Item span={3} label="Всего помещений">
                {data.premisesCount || '-'}
              </Item>
              <Item span={3} label="Жилых помещений">
                {data.flatCount || '-'}
              </Item>
              <Item span={3} label="Нежилых помещений">
                {data.officeCount || '-'}
              </Item>
              <Item span={3} label="Общая площадь дома">
                {data.totalArea || '-'}
              </Item>
              <Item span={3} label="Площадь жилых помещений">
                {data.flatArea || '-'}
              </Item>
              <Item span={3} label="Площадь нежилых помещений">
                {data.officeArea || '-'}
              </Item>
              <Item span={3} label="Общее количество лифтов">
                {data.elevatorCount || '-'}
              </Item>
              <Item span={3} label="Грузовых лифтов">
                {data.serviceElevatorCount || '-'}
              </Item>
              <Item span={3} label="Пассажирских лифтов">
                {data.passengerElevatorCount || '-'}
              </Item>
            </Descriptions>
          </>
        )}
      </Spin>
    </InfoCard>
  );
};

export default AboutHouse;
